<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Máquina
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'maquina-listar' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md q-gutter-sm items-center text-brand-5 text-weight-bold"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          class="input"
          v-model="data.dataInicial"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="data.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          class="input"
          v-model="data.dataFinal"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="data.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-3">
        <div>Maquina</div>
        <q-select
          v-model="maquina"
          option-label="location"
          use-input
          option-value="id"
          :options="options"
          map-options
          dense
          behavior="menu"
          outlined
          @filter="filtrarMaquina"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Dados de Telemetria
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="dadoTelemetria"
        dense
        flat
        no-data-label="Nenhum dado encontrado."
        :hide-bottom="dadoTelemetria.length > 0"
        class="my-sticky-dynamic"
        :rows-per-page-options="[0]"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold" :props="props">
            <td>
              {{
                parseInt(props.row.batterylevel?.split(".")[1]) > 1
                  ? `${props.row.batterylevel?.split(".")[1].padEnd(2, 0)}%`
                  : `${props.row.batterylevel?.split(".")[1].padEnd(3, 0)}%`
              }}
            </td>
            <q-td>
              {{ props.row.connectiontype }}
            </q-td>
            <q-td>
              {{ props.row.isactive ? "Sim" : "Não" }}
            </q-td>
            <q-td>
              {{ props.row.isinteractive ? "Sim" : "Não" }}
            </q-td>
            <q-td>
              {{ props.row.outofservicereason }}
            </q-td>
            <q-td>
              {{ props.row.plugged ? "Sim" : "Não" }}
            </q-td>
            <q-td>
              {{ props.row.protocolo }}
            </q-td>
            <q-td>
              {{ props.row.signalstrength }}
            </q-td>
            <q-td>
              {{ props.row.tenant }}
            </q-td>
            <q-td>
              {{ props.row.userid }}
            </q-td>
            <q-td>
              {{ props.row.versionname }}
            </q-td>
            <q-td>
              {{ props.row.data?.split("-").reverse().join("/") }}
            </q-td>
            <q-td>
              {{
                props.row.created_at
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <span>
                {{ props.row.created_at?.split(" ")[1] }}
              </span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
const columns = [
  {
    name: "bateria",
    label: "Bateria %",
    align: "left",
  },
  {
    name: "tipoConexão",
    label: "Tipo de Conexão",
    align: "left",
  },
  {
    name: "ativo",
    label: "Ativo",
    align: "left",
  },
  {
    name: "interativo",
    label: "Interativo",
    align: "left",
  },
  {
    name: "motivoForaServico",
    label: "Motivo Fora de Serviço",
    align: "left",
  },
  {
    name: "conectado",
    label: "Conectado",
    align: "left",
  },
  {
    name: "protocolo",
    label: "Protocolo",
    align: "left",
  },
  {
    name: "forcaSinal",
    label: "Força do Sinal",
    align: "left",
  },
  {
    name: "tenant",
    label: "Tenant",
    align: "left",
  },
  {
    name: "userId",
    label: "User Id",
    align: "left",
  },
  {
    name: "nomeVersao",
    label: "Nome da Versão",
    align: "left",
  },
  {
    name: "data",
    label: "Data",
    align: "left",
  },
  {
    name: "criadoEm",
    label: "Criado Em",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();
    const route = useRoute();

    const data = ref({
      dataInicial: "",
      dataFinal: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const dadoMaquina = JSON.parse(route.params.maquina);
    const maquina = ref({
      location: dadoMaquina?.nome,
      id: dadoMaquina?.id,
    });
    const dadoTelemetria = ref([]);
    const filtrar = ref(false);
    let loading = ref(false);
    const options = ref([]);

    const receberTelemetria = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          "maquina/receberTelemetriaMaquina",
          {
            data_inicial: data.value.dataInicial,
            data_final: data.value.dataFinal,
            machine_id: maquina.value.id,
          }
        );
        dadoTelemetria.value = response.data.results;
        loading.value = false;
        filtrar.value = true;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const retornarDataInicial = async () => {
      let hoje = new Date();
      let doisDiasAtras = new Date(hoje);
      doisDiasAtras.setDate(hoje.getDate() - 2);

      let dia = doisDiasAtras.getDate();
      let mes = doisDiasAtras.getMonth() + 1;
      let ano = doisDiasAtras.getFullYear();
      if (dia < 10) {
        dia = "0" + dia;
      }
      if (mes < 10) {
        mes = "0" + mes;
      }
      data.value.dataInicial = `${dia}/${mes}/${ano}`;
    };

    const listarMaquinas = async (val) => {
      try {
        let response = await store.dispatch("maquina/listar", {
          vendor_id: store.state.org.unidadeData.id,
          per_page: 20,
          page: 1,
          search: val,
        });

        options.value = response.data.results;
      } catch (error) {
        console.log(error);
      }
    };

    watchDebounced(
      [
        () => data.value.dataInicial,
        () => data.value.dataFinal,
        () => maquina.value.id,
      ],
      () => {
        if (
          data.value.dataInicial != "" &&
          data.value.dataInicial.length != 10
        ) {
          return;
        }
        if (data.value.dataFinal != "" && data.value.dataFinal.length != 10) {
          return;
        }
        if (filtrar.value) {
          receberTelemetria();
        }
      },
      { debounce: 400 }
    );

    onMounted(async () => {
      await retornarDataInicial();
      receberTelemetria();
    });

    return {
      columns,
      receberTelemetria,
      retornarDataInicial,
      listarMaquinas,
      filtrarMaquina(val, update) {
        listarMaquinas(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      options,
      loading,
      maquina,
      dadoTelemetria,
      data,
      dadoMaquina,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.texto-titulo {
  font-size: 20px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.titulo-tabela {
  font-size: 18px;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
